import { createQueryHook } from '@hooks/createQueryHook'
import { createMutationHook } from '@hooks/createMutationHook'

// Available buy-bonus packages. No params.
export const useBuyBonusPackages = createQueryHook('buyBonus.packages')

// Purchase a package (mutation). Refreshes freebets + packages on success.
// Usage: const { mutate } = useBuyBonusPackage(); mutate({ packageValue, packageId })
export const useBuyBonusPackage = createMutationHook('buyBonus.purchase')
